
import Vue from 'vue'

interface SearchInfoData {}

interface SearchInfoMethods {}

interface SearchInfoComputed {
    query: string,
    total: number,
}


export default Vue.extend<SearchInfoData, SearchInfoMethods, SearchInfoComputed, {}>({
	name: 'FilterComponent',
	computed: {
		query() {
            return this.$store.state.query;
        },
        total() {
            return this.$store.state.total;
        }
	},
})
